import { createSend } from '../clients';

export type SendBetParams = {
	wager: number;
	clientSeed: string;
};

export const sendBet = createSend('bet').prepend<SendBetParams>((pld) => ({
	...pld,
	minesNumber: 0,
}));
